import React from 'react';
import { SnapDialog, TextField } from '@one-snap/sparkles';
import { Typography, Link } from '@mui/material';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PropTypes from 'prop-types';
import { message } from 'antd';

function SampleInfoCard({ isCardVisible, setCardVisible }) {
  return (
    <SnapDialog
      data-testid="checkout-partner-modal"
      open={isCardVisible}
      onClose={() => setCardVisible(false)}
      style={{
        width: 320,
        position: 'fixed',
        right: '40 !important',
        borderRadius: 10
      }}
    >
      <div style={{ position: 'relative', padding: '10px' }}>
        <Typography variant="h7" gutterBottom>
          <u>Approval Test Data</u>
        </Typography>

        <Typography variant="body1" style={{ marginTop: 10, fontSize: 12 }}>
          Verify with a{' '}
          <Link
            href="https://receive-smss.com/sms/19174195208/"
            target="_blank"
            rel="noreferrer"
          >
            real phone number
          </Link>
          .
        </Typography>

        <CopyToClipboard text="07/07/1977">
          <TextField
            label="Date of Birth"
            value="07/07/1977"
            readOnly
            onClick={() => message.success('Copied to clipboard!')}
            fullWidth
            style={{ marginTop: 10 }}
          />
        </CopyToClipboard>

        <CopyToClipboard text="976908619">
          <TextField
            label="SSN OR ITIN"
            value="976908619"
            readOnly
            onClick={() => message.success('Copied to clipboard!')}
            fullWidth
            style={{ marginTop: 10 }}
          />
        </CopyToClipboard>

        <CopyToClipboard text="021000021">
          <TextField
            label="Bank Routing Number"
            value="021000021"
            readOnly
            onClick={() => message.success('Copied to clipboard!')}
            fullWidth
            style={{ marginTop: 10 }}
          />
        </CopyToClipboard>

        <CopyToClipboard text="76557657657">
          <TextField
            label="Bank Account Number"
            value="76557657657"
            readOnly
            onClick={() => message.success('Copied to clipboard!')}
            fullWidth
            style={{ marginTop: 10 }}
          />
        </CopyToClipboard>
      </div>
    </SnapDialog>
  );
}
SampleInfoCard.propTypes = {
  isCardVisible: PropTypes.bool.isRequired,
  setCardVisible: PropTypes.func.isRequired
};

export default SampleInfoCard;
